import React from 'react'
import { IconButton, Typography } from '@material-ui/core'
import { Trash2, Upload } from 'lib/lucide'

import { UploadButton } from 'components/UploadButton'

import { useStyles } from './styles'

interface ImageUploadFieldProps {
  id: string
  label: React.ReactNode
  preview?: string
  onChange: (file: File) => void
  onDelete?: () => void
  onPreviewError?: () => void
  variant?: 'square' | 'wide'
  accept?: string
  maxSizeInMB?: number
  hint?: string
  error?: string
}

const ImageUploadField: React.FC<ImageUploadFieldProps> = ({
  id,
  label,
  preview,
  onChange,
  onDelete,
  onPreviewError,
  variant = 'square',
  accept = '.jpg, .jpeg, .png',
  maxSizeInMB,
  hint,
  error,
}) => {
  const classes = useStyles()
  const hasPreview = Boolean(preview)

  const hasError = Boolean(error)

  return (
    <div className={classes.root}>
      <span className={`${classes.label}${hasError ? ` ${classes.labelError}` : ''}`}>{label}</span>
      {hint ? <span className={classes.hint}>{hint}</span> : null}
      <div
        className={`${classes.card} ${variant === 'wide' ? classes.cardWide : classes.cardSquare}`}
      >
        {hasPreview && onDelete ? (
          <IconButton
            className={classes.deleteButton}
            onClick={onDelete}
            aria-label="Eliminar imagen"
          >
            <Trash2 size={16} />
          </IconButton>
        ) : null}
        <div className={classes.contentArea}>
          {hasPreview ? (
            <img src={preview} alt="" className={classes.preview} onError={onPreviewError} />
          ) : (
            <>
              <Upload size={36} className={classes.emptyIcon} />
              <Typography className={classes.emptyText}>Busca una imagen en tu equipo.</Typography>
            </>
          )}
        </div>
        <div className={classes.actions}>
          <UploadButton
            id={hasPreview ? `${id}-replace` : id}
            accept={accept}
            label={hasPreview ? 'Cambiar' : 'Buscar'}
            onChange={onChange}
            maxSizeInMB={maxSizeInMB}
          />
        </div>
      </div>
    </div>
  )
}

export { ImageUploadField }
